const ProductIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_10_102)">
        <rect x="1" y="3" width="12" height="18" rx="2" stroke="#262626" stroke-width="2"></rect>
        <path d="M15.979 5.27753L17.3498 5.96293C18.2106 6.39334 18.6428 7.37583 18.3784 8.30123L15.979 16.6992" stroke="#262626" stroke-width="2" stroke-linecap="round"></path>
        <path d="M21.0994 8.46658L22.6948 10.3811C23.1511 10.9287 23.1591 11.7218 22.7138 12.2784L15.8644 20.8401" stroke="#262626" stroke-width="2" stroke-linecap="round"></path>
      </g>
      <defs>
        <clipPath id="clip0_10_102"><rect width="24" height="24" fill="white">
        </rect>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProductIcon;
